import Vue from 'vue'

import './styles/quasar.styl'
import lang from 'quasar/lang/es.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import {
  Quasar, 
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QSeparator,
  QFooter,
  QTabs,
  QTab,
  QRouteTab,
  QInput,
  QCard,
  QCardSection,
  QCardActions,
  QDialog,
  ClosePopup
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,

    QSeparator,
    QFooter,
    QTabs,
    QTab,
    QRouteTab,
    QInput,
    QCard,
    QCardSection,
    QCardActions,
    QDialog,
    ClosePopup,
  },
  directives: {
    ClosePopup
  },
  plugins: {
  },
  lang: lang
 })